import React, { useState } from 'react';
import PopUp from '../../../Shared/Popup/PopUp';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit'
import InfoEsimPopup from '../popupComponent/InfoEsimPopup'

export const EsimInstallation = (props) => {
  const [isShowPopUp, setPopUp] = useState(false);

  return (
    <>
      <div className='esimContainer'>
        <div
          className='actionButton'
          onClick={() => setPopUp(true)}>
          להפעלת ה-eSIM
        </div>
      </div>

      <PopUp preventWrapperClose={true} showPopUp={isShowPopUp} onClose={() => setPopUp(false)}>
        <InfoEsimPopup esimData={props.esimData} isPopUp={isShowPopUp} footerButton={<BtnSubmit onclick={() => setPopUp(false)} text='הבנתי, תודה' />} />
      </PopUp>
    </>
  );
};

export default EsimInstallation;
